<template>
    <div class="body-content">
        <div class="container">
            <el-container>
                <div class="demo-image">
                    <img src="../../assets/img/Illustration.png" alt="">
                </div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                  <el-form-item>
                    <h1>Dayee大易接口平台</h1>
                  </el-form-item>
                  <el-form-item prop="corpCode">
                    <el-input
                      placeholder="企业code"
                      v-model="ruleForm.corpCode"
                       @keyup.enter.native="handleValidate('ruleForm')">
                      <img :src="svg.codesvg" slot="prefix">
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="userName">
                    <el-input
                      placeholder="用户名"
                      v-model="ruleForm.userName"
                       @keyup.enter.native="handleValidate('ruleForm')">
                      <img :src="svg.usrsvg" slot="prefix">
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input
                      placeholder="请输入密码"
                      type="password"
                      v-model="ruleForm.password"
                      @input="ruleForm.pswMD5 = ''"
                       @keyup.enter.native="handleValidate('ruleForm')">
                      <img :src="svg.pswsvg" slot="prefix">
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-row>
                      <el-col :span="16">
                        <el-button type="primary" class="LoginButton" @click="handleValidate('ruleForm')">登录</el-button>
                      </el-col>
                      <el-col :span="8">
                        <el-checkbox style="display: flex;align-items: center; justify-content: center; width:100%; height:52px;" v-model="rememberChecked">记住我</el-checkbox>
                      </el-col>
                    </el-row>
                  </el-form-item>
                </el-form>
            </el-container>
        </div>
    </div>
</template>

<script>
import { cookie } from 'cookie.js'
import codesvg from '../../assets/img/code.svg'
import usrsvg from '../../assets/img/username.svg'
import pswsvg from '../../assets/img/password.svg'
import constant from '../../utils/constant'
import md5 from 'js-md5'
import { Loading } from 'element-ui'

export default {
  data () {
    return {
      ruleForm: {
        corpCode: '',
        userName: '',
        password: '',
        pswMD5: ''
      },
      rules: {
        corpCode: [
          { required: true, message: '请输入企业Code', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      svg: {
        codesvg: codesvg,
        usrsvg: usrsvg,
        pswsvg: pswsvg
      },
      rememberChecked: false
    }
  },
  created: function () {
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('userType')
    this.handleGetCookieUser()
  },
  methods: {
    async handleValidate (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.handleSubmit()
        } else {
          return false
        }
      })
    },
    async handleSubmit () {
      let that = this
      // MD5加密
      if (!that.ruleForm.pswMD5) {
        that.ruleForm.pswMD5 = md5(that.ruleForm.password).toUpperCase()
      }
      await this.$api.login.loginApi(
        {
          corpCode: that.ruleForm.corpCode,
          userName: that.ruleForm.userName,
          password: that.ruleForm.pswMD5
        }
      )
        .then(function (res) {
          if (res.data.data.token) {
            sessionStorage.setItem('token', res.data.data.token)
            sessionStorage.setItem('userType', res.data.userType)
            const loadingInstance = Loading.service({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            setTimeout(() => {
              // vuex状态记录
              that.$store.state.loginInfo = {
                corpCode: that.ruleForm.corpCode,
                userName: that.ruleForm.userName,
                password: that.ruleForm.password,
                token: res.data.data.token,
                userType: res.data.userType // 登录用户类型：0管理员，1接口用户
              }
              loadingInstance.close()
              that.handleSetCookieUser()
              setTimeout(() => {
                constant.giveMessage('登录成功！', 'success')
              }, 200)
              setTimeout(() => {
                that.$router.push({ path: constant.pathPre + '/Home/Index' })
              }, 500)
            }, 500)
          } else {
            constant.giveMessage('登录失败！', 'error')
          }
        })
        .catch(function (err) {
          console.log(err)
          constant.giveMessage('系统错误，请联系管理员！', 'error')
        })
    },
    handleSetCookieUser () {
      if (this.rememberChecked) {
        let data = [this.ruleForm.corpCode, this.ruleForm.userName, this.ruleForm.pswMD5]
        cookie.set('WT_API_USER', encodeURIComponent(data.join(',')))
      }
    },
    handleGetCookieUser () {
      let wtApiUser = cookie.get('WT_API_USER')
      if (wtApiUser) {
        this.ruleForm.corpCode = (decodeURIComponent(wtApiUser) && decodeURIComponent(wtApiUser).split(',')[0]) || ''
        this.ruleForm.userName = (decodeURIComponent(wtApiUser) && decodeURIComponent(wtApiUser).split(',')[1]) || ''
        this.ruleForm.password = (decodeURIComponent(wtApiUser) && decodeURIComponent(wtApiUser).split(',')[2]) || ''
        this.ruleForm.pswMD5 = (decodeURIComponent(wtApiUser) && decodeURIComponent(wtApiUser).split(',')[2]) || ''
        this.rememberChecked = true
      }
    }
  }
}
</script>

<style scoped>
    .body-content{
        width: 100%;
        height: 100%;
        background: transparent url('../../assets/img/background.png') 0% 0% padding-box;
        background-size: cover;
        display:flex;/*弹性盒模型*/
        justify-content: center;/*主轴居中对齐*/
        align-items: center;/*侧轴居中对齐*/
    }
    .el-container{
        width: 1150px;
        height: 588px;
        margin: 0 auto;
        background: #FEFDFD 0% 0% no-repeat padding-box;
        border-radius: 20px;
        opacity: 1;
        position: relative;
    }
        .demo-image{
            display: block;
            top: 116px;
            left: 58px;
            width: 546px;
            height: 356px;
            opacity: 1;
            position: absolute;
        }
        .el-form{
            top: 108px;
            left: 665px;
            width: 381px;
            height: 371px;
            position: absolute;
            opacity: 1;
        }
        .el-form-item{
            padding: 12.5px 0;
            margin-bottom: 0
        }
        .el-form-item:nth-child(2){
            margin-top: 30px !important;
        }
        .el-form-item:nth-child(4){
            margin-bottom: 27.5px !important;
        }
        .el-form-item:nth-child(5)
        {
          padding: 0;
        }
            .el-form-item h1{
                text-align: left !important;
                font: Bold 26px/21px Microsoft YaHei;
                letter-spacing: 0;
                color: #262626;
                opacity: 1;
            }
            /* 深度作用选择器el-input样式 */
            .el-input /deep/ .el-input__prefix{
              width: 50px;
              display:flex;
              justify-content: center;
              align-items: center;
            }
            .el-input--prefix /deep/ .el-input__inner {
                width: 381px;
                height: 50px;
                line-height: 50px;
                background: #F1F1F1 0% 0% no-repeat padding-box;
                border: 1px solid #FEFDFD;
                border-radius: 27px !important;
                padding-left: 50px;
            }
            .el-input--prefix /deep/ .el-input__inner:focus {
              border: 1px solid #3B5EFEBD;
            }

            .el-form /deep/ .el-form-item__error{
              padding-left: 50px;
            }

            .LoginButton{
                /*width: 381px;*/
                width:100%;
                height: 52px;
                background: #354ECE;
                box-shadow: 0px 4px 10px #CCD5FE;
                border-radius: 28px;
                opacity: 1;
                font: Regular 16px/19px Microsoft YaHei;
                letter-spacing: 0;
                color: #FFFFFF;
            }

/* 取消google浏览器input自动填充颜色的问题 */
.body-content /deep/ input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #F1F1F1 inset;
  -webkit-box-shadow: 0 0 0px 1000px #F1F1F1 inset;
  -webkit-text-fill-color: #333;
}
</style>



// WEBPACK FOOTER //
// src/containers/Login/Index.vue